import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default class ProductCategories {
  constructor() {
    this.getDomElements()

    if (!this.dom.productCategories.length) return

    gsap.registerPlugin(ScrollTrigger);
    
    this.init()
  }

  init() {
    this.dom.productCategories.forEach(section => {
      ScrollTrigger.create({
        trigger: section,
        start: "60% 100%",
        onEnter: () => {
          section.classList.add('is-active')
        },
        onLeaveBack: () => {
          section.classList.remove('is-active')
        }
      })
    })
  }

  getDomElements() {
    this.dom = {
      'productCategories' : document.querySelectorAll('.js-product-categories')
    }
  }
}